import type { PropsWithChildren } from "react";

export function Skeleton({ className, children }: PropsWithChildren<{ className?: string }>) {
  return <div className={`${className} animate-pulse bg-black-olive rounded-4`}>{children}</div>;
}
